import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-borrower-transaction-page',
    templateUrl: './borrower-transaction-page.component.html',
    styleUrl: './borrower-transaction-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BorrowerTransactionPageComponent {
}
